import {Component, Input} from '@angular/core';
import {AuthService} from '../../../../services/auth/auth.service';
import {ValidationService} from '../../../../services/validation/validation.service';
import {CustomerService} from '../../../../services/customer/customer.service';
import {UtilService} from "../../../../services/util/util.service";
import {WebshopCustomer} from "../../../../generated/customer-client";
import {finalize} from 'rxjs/operators';
import {CartAdvancedInterface} from '../../../../services/cart/cart.interface';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {Privileges} from '../../../admin/privileges/privileges.constants';
import {CartTypes} from '../../../../services/cart/cart-base.service';
import {TextInputType} from '../../../../components/forms/text-input/text-input.component';
import {NumericInputType} from '../../../../components/forms/numeric-input/numeric-input.component';

@Component({
  selector: 'app-cart-actions',
  templateUrl: './cart-actions.component.html',
  styleUrls: ['./cart-actions.component.scss']
})
export class CartActionsComponent<Type> {
  @Input() service: CartAdvancedInterface<Type>;
  @Input() bulkMode: boolean;

  public discount: number;
  public filtering: boolean;
  public filteringValue: string;
  public hasResults: boolean;
  public customerUsername = '';
  public customers: WebshopCustomer[] = [];
  public Privileges = Privileges;
  public CartTypes = CartTypes;

  constructor(public authService: AuthService,
              public utilService: UtilService,
              private customerService: CustomerService) {}

  public searchCustomer(event: KeyboardEvent): void {
    const target: any = event.target,
      value = target.value.toString();
    if (ValidationService.isEnterOrArrowKeysPressed(event)) { return; }
    if (ValidationService.validateString(value, 3)) {
      this.filteringValue = value;
    }
    if (!this.filtering && this.filteringValue && this.filteringValue.length) {
      this.filtering = true;
      this.customerService.searchFromWebshop(this.filteringValue).pipe(
        finalize(() => {
          this.hasResults = !!this.customers.length;
          this.filtering = false;
          this.filteringValue = '';
        })
      ).subscribe(results => this.customers = results);
    } else {
      this.customers = [];
      this.service.webShopCustomer = null;
    }
  }
  public selectCustomer(event: MatAutocompleteSelectedEvent): void {
    if (event.option.value) {
      this.service.webShopCustomer = event.option.value || null;
    }
  }
  public displayFnCustomer(option: WebshopCustomer): string | undefined {
    const userDetails = [];
    if (!option) {
      return undefined;
    }
    if (option.email && option.email.length > 0) {
      userDetails.push(option.email);
    }
    return (option.userName || '') + ' ' + (option.name || '') + ' ' + (userDetails.length ? ' (' + userDetails.join(', ') + ')' : '');
  }
  public get checkCustomerAutocomplete(): boolean {
    return !(this.customerUsername && !this.service.webShopCustomer);
  }

  public get isValidClientNotificationEmail(): boolean {
    return !this.service.clientNotificationEmail || ValidationService.validateEmail(this.service.clientNotificationEmail);
  }

  protected readonly TextInputType = TextInputType;
  protected readonly NumericInputType = NumericInputType;
}
